import React, { useCallback, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { store } from "react-notifications-component";
import api from "../../services/api";
import GenericUpper from "../../components/generic-upper";
import Input from "../../components/input/input_v2";
import Select from "../../components/select/select_v2";
import Button from "../../components/button/button_v2";
import estados from "../../services/estados";
import { Container } from "react-grid-system";
import { ContainerInputCultura, ProdutoresAddContainer, YesNoContainer } from "./styles";
import ModalEditLocal from "../../components/modal/modalEditProdutor";
import ModalYesNo from "../../components/modal/modalYesNo";
import ModalText from "../../components/modal/modalText";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";

import { Multiselect } from 'multiselect-react-dropdown';
import buscaCep from "../../services/buscaCep";
import Modal from "../../components/modal/modalGeneric";
import Interruptor from "../../components/interruptor";
import MapaArea from "../../components/mapaArea";
import { isTotvs, isOmie } from "../../services/globalFunctions";
import { theme } from "../../styles/theme";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";

const formatCPFOrCNPJ = (value) => {
    const cleaned = (value || '').replace(/\D/g, '').slice(0, 14);
    if (cleaned.length <= 11) {
        return cleaned
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
    } else {
        return cleaned
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/\.(\d{3})(\d)/, '.$1/$2')
            .replace(/(\d{4})(\d{1,2})$/, '$1-$2');
    }
};

const formatCEP = (value) => {
    const cleaned = (value || '').replace(/\D/g, '').slice(0, 8);
    return cleaned.replace(/^(\d{5})(\d{1,3})?$/, (match, p1, p2) =>
        p2 ? `${p1}-${p2}` : p1
    );
};

const EditLocal = ({ ...props }) => {

    const [nomeLocal, setNomeLocal] = useState('');
    const [cpfCnpjLocal, setCpfCnpjLocal] = useState('');
    const [inscricaoEstadual, setInscricaoEstadual] = useState('');
    const [cepLocal, setCepLocal] = useState('');
    const [logradouroLocal, setLogradouroLocal] = useState('');
    const [bairroLocal, setBairroLocal] = useState('');
    const [numeroLocal, setNumeroLocal] = useState('');
    const [complementoLocal, setComplementoLocal] = useState('');
    const [cidadeLocal, setCidadeLocal] = useState('');
    const [codIbge, setCodIbge] = useState('');
    const [loadingIbge, setLoadingIbge] = useState(false);
    const [estadoLocal, setEstadoLocal] = useState('');
    const [numeroOrgao, setNumeroOrgao] = useState('');
    const [areaTotal, setAreaTotal] = useState('');
    const [cadastroAmbiental, setCadastroAmbiental] = useState('');
    const [latitude, setLatitude] = useState('');
    const [longitude, setLongitude] = useState('');
    const [culturaId, setCulturaId] = useState('');
    const [culturas, setCulturas] = useState([]);
    const [estadoCep, setEstadoCep] = useState('');
    const [id, setId] = useState('');
    const [id_produtor, setIdProdutor] = useState('');
    const [msg, setMsg] = useState('');
    const [msg2, setMsg2] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalYesNo, setShowModalYesNo] = useState(false);
    const [locais, setLocais] = useState([]);
    const [enviadoCrea, setEnviadoCrea] = useState(false);
    const [respostaCrea, setRespostaCrea] = useState('');
    const [respostaArt, setRespostaArt] = useState('');
    const [selectedValues, setSelectedValues] = useState([]);
    const [culturassend, setCulturassend] = useState([]);
    const [newcultures, setNewCultures] = useState([]);
    const [showModalText, setShowModalText] = useState(false);
    const [cepInicial, setCepInicial] = useState('');
    const [logradouroInicial, setLogradouroInicial] = useState('');
    const [numeroInicial, setNumeroInicial] = useState('');
    const [enderecoInicial, setEnderecoInicial] = useState('');
    const [latitudeGraus, setLatitudeGraus] = useState('');
    const [latitudeMinutos, setLatitudeMinutos] = useState('');
    const [latitudeSegundos, setLatitudeSegundos] = useState('');
    const [longitudeGraus, setLongitudeGraus] = useState('');
    const [longitudeMinutos, setLongitudeMinutos] = useState('');
    const [longitudeSegundos, setLongitudeSegundos] = useState('');
    const [loading, setLoading] = useState(false);
    const [altitude, setAltitude] = useState('');
    const [erroLatitude, setErroLatitude] = useState(false);
    const [erroLongitude, setErroLongitude] = useState(false);
    const [erroAltitude, setErroAltitude] = useState(false);
    const [erroLatitudeGraus, setErroLatitudeGraus] = useState(false);
    const [erroLatitudeMinutos, setErroLatitudeMinutos] = useState(false);
    const [erroLatitudeSegundos, setErroLatitudeSegundos] = useState(false);
    const [erroLongitudeGraus, setErroLongitudeGraus] = useState(false);
    const [erroLongitudeMinutos, setErroLongitudeMinutos] = useState(false);
    const [erroLongitudeSegundos, setErroLongitudeSegundos] = useState(false);
    const [erroNome, setErroNome] = useState(false);
    const [erroNomeMsg, setErroNomeMsg] = useState('');
    const [erroIbge, setErroIbge] = useState(false);
    const [erroIbgeMsg, setErroIbgeMsg] = useState('');
    const [erroCpf, setErroCpf] = useState(false);
    const [erroBairro, setErroBairro] = useState(false);
    const [erroBairroMsg, setErroBairroMsg] = useState('');
    const [erroCep, setErroCep] = useState(false);
    const [erroCepMsg, setErroCepMsg] = useState('');
    const [erroEndereco, setErroEndereco] = useState(false);
    const [erroEnderecoMsg, setErroEnderecoMsg] = useState('');
    const [erroNumero, setErroNumero] = useState(false);
    const [erroNumeroMsg, setErroNumeroMsg] = useState('');
    const [erroCidade, setErroCidade] = useState(false);
    const [erroCidadeMsg, setErroCidadeMsg] = useState('');
    const [erroEstado, setErroEstado] = useState(false);
    const [erroEstadoMsg, setErroEstadoMsg] = useState('');
    const [erroCpfMsg, setErroCpfMsg] = useState('');
    const [resolveConflict, setResolveConflict] = useState([]);
    const [btnCancelar, setBtnCancelar] = useState(false);
    const [modalGeneric, setModalGeneric] = useState(<></>);
    const [showModalGeneric, setShowModalGeneric] = useState(false);
    const [responseConflict, setResponseConflict] = useState([]);
    const [showMap, setShowMap] = useState(false);
    const [showInput, setShowInput] = useState(false);
    const [modoCoord, setModoCoord] = useState(0);
    const [statusLocal, setStatusLocal] = useState(0);
    const [estadosObrigatorios, setEstadosObrigatorios] = useState(["ES", "PR", "GO", "SC", "SP"]);

    const isEstadoObrigatorio = useCallback(
        (estado) => estadosObrigatorios.includes(estado),
        [estadosObrigatorios]
    );

    useEffect(() => {
        const getEstadosCood = async () => {
            try {
                const response = await api.get(`/fazendas/estados`);

                let estados = [];
                if (response && response.data) {
                    if (Array.isArray(response.data.estados)) {
                        estados = response.data.estados;
                    } else if (response.data.data && Array.isArray(response.data.data.estados)) {
                        estados = response.data.data.estados;
                    }
                }

                if (Array.isArray(estados) && estados.length > 0) {
                    setEstadosObrigatorios(estados);
                }
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(error),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        };

        getEstadosCood();
    }, []);


    // Função para detectar se a coordenada está em formato DMS
    function isDMSFormat(coord) {
        if (!coord || typeof coord !== 'string') return false;
        // Verifica se contém os símbolos de graus (°), minutos (') e segundos (")
        return coord.includes('°') && coord.includes("'") && coord.includes('"');
    }

    // Função para converter DMS para componentes separados
    function parseDMSCoordinate(dmsString) {
        if (!isDMSFormat(dmsString)) return null;
        
        // Regex para extrair graus, minutos e segundos
        const dmsRegex = /(\d{1,3})°(\d{1,2}(?:\.\d+)?)'(\d{1,2}(?:\.\d+)?)?"([NSEW])/;
        const match = dmsString.match(dmsRegex);
        
        if (!match) return null;
        
        return {
            graus: match[1].padStart(2, '0'), // Garante 2 dígitos
            minutos: match[2].padStart(2, '0'), // Garante 2 dígitos  
            segundos: match[3] ? match[3].padStart(4, '0') : '0000', // Garante 4 dígitos (com decimais)
            direcao: match[4]
        };
    }

    const inicializa = async () => {
        try {

            const responseCulturas = await api.get(`culturas`);
            let c = responseCulturas.data.data;
            c = formatCulturas(c);
            setCulturas(c)

            let id = "";
            let idProdutor = "";

            if (props.idFazenda && props.idProdutor) {
                id = props.idFazenda;
                idProdutor = props.idProdutor;
            } else {
                id = props.match.params.idfazenda;
                idProdutor = props.match.params.idprodutor;
            }


            setId(id);
            setIdProdutor(idProdutor)

            const response = await api.get(`/fazendas/${id}`);

            const fazenda = response.data.data;

            if (Array.isArray(fazenda)) {
                fazenda.forEach((item) => {
                    setNomeLocal(item.nome)
                    setNomeLocal(item.nome);
                    setCpfCnpjLocal(item.cpf_cnpj);
                    setCodIbge(item.cod_ibge);
                    setAreaTotal(item.area_total);
                    setInscricaoEstadual(item.inscricao_estadual);
                    setCadastroAmbiental(item.cadastro_ambiental);
                    setNumeroOrgao(item.inscricao_orgao);
                    setCepLocal(item.cep);
                    setLogradouroLocal(item.endereco);
                    setNumeroLocal(item.numero);
                    setComplementoLocal(item.complemento);
                    setCidadeLocal(item.cidade);
                    setBairroLocal(item.bairro);
                    setEstadoLocal(item.estado);
                    setEstadoCep(item.estado);
                    setCepInicial(item.cep);
                    setLogradouroInicial(item.endereco);
                    setNumeroInicial(item.numero);
                    setEnderecoInicial([item.endereco, item.numero, item.bairro, item.cidade, item.estado, item.cep].filter(Boolean).join(', '));

                    // Processar coordenadas - verificar se são DMS ou decimal
                    if (item.latitude && item.longitude) {
                        if (isDMSFormat(item.latitude) && isDMSFormat(item.longitude)) {
                            // Coordenadas em formato DMS - quebrar em componentes e configurar modo input
                            const latDMS = parseDMSCoordinate(item.latitude);
                            const lngDMS = parseDMSCoordinate(item.longitude);
                            
                            if (latDMS && lngDMS) {
                                setLatitudeGraus(latDMS.graus);
                                setLatitudeMinutos(latDMS.minutos);
                                setLatitudeSegundos(latDMS.segundos);
                                setLongitudeGraus(lngDMS.graus);
                                setLongitudeMinutos(lngDMS.minutos);
                                setLongitudeSegundos(lngDMS.segundos);
                                
                                // Configurar modo para mostrar os inputs DMS
                                setModoCoord({ value: 2, label: 'Digitar coordenadas' });
                                setShowInput(true);
                                setShowMap(false);
                                
                                // Limpar os campos de coordenadas decimais
                                setLatitude('');
                                setLongitude('');
                            } else {
                                // Fallback se não conseguir parsear
                                setLatitude(item.latitude);
                                setLongitude(item.longitude);
                                // Configurar modo para mostrar o mapa
                                setModoCoord({ value: 1, label: 'Selecionar no mapa' });
                                setShowMap(true);
                                setShowInput(false);
                            }
                        } else {
                            // Coordenadas em formato decimal - comportamento atual (mostrar mapa)
                            setLatitude(item.latitude);
                            setLongitude(item.longitude);
                            
                            // Configurar modo para mostrar o mapa
                            setModoCoord({ value: 1, label: 'Selecionar no mapa' });
                            setShowMap(true);
                            setShowInput(false);
                            
                            // Limpar os campos DMS
                            setLatitudeGraus('');
                            setLatitudeMinutos('');
                            setLatitudeSegundos('');
                            setLongitudeGraus('');
                            setLongitudeMinutos('');
                            setLongitudeSegundos('');
                        }
                    } else {
                        setLatitude(item.latitude);
                        setLongitude(item.longitude);
                    }
                    
                    setAltitude(item.altitude);
                    setStatusLocal(item.status);
                    const select = formatCulturas(item.cultura);
                    setSelectedValues(select);

                    let cultures = [];

                    if (fazenda.cultura) {
                        fazenda.cultura.map((fc) => {
                            cultures = [...cultures, fc.id]
                        })
                    }

                    setCulturassend(cultures);
                });
            } else {
                // Se não for um array, trata como um único objeto
                setNomeLocal(fazenda.nome);
                setCpfCnpjLocal(fazenda.cpf_cnpj);
                setCodIbge(fazenda.cod_ibge);
                setAreaTotal(fazenda.area_total);
                setInscricaoEstadual(fazenda.inscricao_estadual);
                setCadastroAmbiental(fazenda.cadastro_ambiental);
                setNumeroOrgao(fazenda.inscricao_orgao);
                setCepLocal(fazenda.cep);
                setLogradouroLocal(fazenda.endereco);
                setNumeroLocal(fazenda.numero);
                setComplementoLocal(fazenda.complemento);
                setCidadeLocal(fazenda.cidade);
                setBairroLocal(fazenda.bairro);
                setEstadoLocal(fazenda.estado);
                setEstadoCep(fazenda.estado);
                setCepInicial(fazenda.cep);
                setLogradouroInicial(fazenda.endereco);
                setNumeroInicial(fazenda.numero);
                setEnderecoInicial([fazenda.endereco, fazenda.numero, fazenda.bairro, fazenda.cidade, fazenda.estado, fazenda.cep].filter(Boolean).join(', '));

                // Processar coordenadas - verificar se são DMS ou decimal
                if (fazenda.latitude !== null && fazenda.longitude !== null) {
                    if (isDMSFormat(fazenda.latitude) && isDMSFormat(fazenda.longitude)) {
                        // Coordenadas em formato DMS - quebrar em componentes e configurar modo input
                        const latDMS = parseDMSCoordinate(fazenda.latitude);
                        const lngDMS = parseDMSCoordinate(fazenda.longitude);
                        
                        if (latDMS && lngDMS) {
                            setLatitudeGraus(latDMS.graus);
                            setLatitudeMinutos(latDMS.minutos);
                            setLatitudeSegundos(latDMS.segundos);
                            setLongitudeGraus(lngDMS.graus);
                            setLongitudeMinutos(lngDMS.minutos);
                            setLongitudeSegundos(lngDMS.segundos);
                            
                            // Configurar modo para mostrar os inputs DMS
                            setModoCoord({ value: 2, label: 'Digitar coordenadas' });
                            setShowInput(true);
                            setShowMap(false);
                            
                            // Limpar os campos de coordenadas decimais
                            setLatitude('');
                            setLongitude('');
                        } else {
                            // Fallback se não conseguir parsear
                            if (!isValidCoordinate(fazenda.latitude) || !isValidCoordinate(fazenda.longitude)) {
                                store.addNotification({
                                    title: "Erro!",
                                    message: "Coordenadas inválidas.",
                                    type: "danger",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 5000,
                                        onScreen: true
                                    }
                                });
                            } else {
                                setLatitude(fazenda.latitude);
                                setLongitude(fazenda.longitude);
                                // Configurar modo para mostrar o mapa
                                setModoCoord({ value: 1, label: 'Selecionar no mapa' });
                                setShowMap(true);
                                setShowInput(false);
                            }
                        }
                    } else {
                        // Coordenadas em formato decimal - comportamento atual (mostrar mapa)
                        if (!isValidCoordinate(fazenda.latitude) || !isValidCoordinate(fazenda.longitude)) {
                            store.addNotification({
                                title: "Erro!",
                                message: "Coordenadas inválidas.",
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 5000,
                                    onScreen: true
                                }
                            });
                        } else {
                            setLatitude(fazenda.latitude);
                            setLongitude(fazenda.longitude);
                            
                            // Configurar modo para mostrar o mapa
                            setModoCoord({ value: 1, label: 'Selecionar no mapa' });
                            setShowMap(true);
                            setShowInput(false);
                            
                            // Limpar os campos DMS
                            setLatitudeGraus('');
                            setLatitudeMinutos('');
                            setLatitudeSegundos('');
                            setLongitudeGraus('');
                            setLongitudeMinutos('');
                            setLongitudeSegundos('');
                        }
                    }
                }

                setAltitude(fazenda.altitude);
                setStatusLocal(fazenda.status);

                const select = formatCulturas(fazenda.cultura);
                setSelectedValues(select);

                let cultures = [];

                if (fazenda.cultura) {
                    fazenda.cultura.map((fc) => {
                        cultures = [...cultures, fc.id]
                    })
                }

                setCulturassend(cultures);
            }

            function isValidCoordinate(coord) {
                if (coord === null || coord === undefined || coord === "") return false;

                if (!isNaN(Number(coord))) return true;
            }
        } catch (error) {
        }

    }

    const formatCulturas = (culturas) => {
        if (Array.isArray(culturas)) {
            return culturas.map((cultura) => ({
                id: cultura.id,
                name: cultura.nome_comum,
            }));
        } else if (culturas) {
            return {
                id: culturas.id,
                name: culturas.nome_comum,
            };
        }
        return [];
    };

    const validateNome = nomeLocal => {
        setNomeLocal(nomeLocal);
        setErroNome(false);

    }

    const validateNumero = numeroLocal => {
        setNumeroLocal(numeroLocal);
        setErroNumero(false);

    }

    const validateCpfCnpjLocal = cpfCnpjLocal => {
        setErroCpf(false);
        setCpfCnpjLocal(cpfCnpjLocal);
    }

    const validaCpf = async (valor) => {
        if (!valor) {
            setErroCpf(false);
            return;
        }

        const resultado = await validadorCpfCnpj(valor);

        setErroCpf(!resultado.valido);
        setErroCpfMsg(resultado.erro || 'Informe um CPF/CNPJ válido!');

        if (!resultado.valido) {
            store.addNotification({
                title: "Erro!",
                message: resultado.erro || "Informe um CPF/CNPJ válido.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const fetchCep = (cepLocal) => {
        setCepLocal(cepLocal);
        setErroCep(false);
    };

    const validaCep = async (cepLocal) => {
        try {
            const cep = await buscaCep(cepLocal);
            const { logradouro, localidade, bairro, ibge, uf } = cep;

            setLogradouroLocal(logradouro);
            setCidadeLocal(localidade);
            setBairroLocal(bairro);
            setCodIbge(ibge);
            setEstadoLocal(uf);
            setEstadoCep(uf);
            setErroCep(false);
            setErroEndereco(false);
            setErroBairro(false);
            setErroCidade(false);
            setErroIbge(false);
        } catch (err) {
            store.addNotification({
                title: "Erro!",
                message: err.message,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const limpaCep = e => {
        if ((estadoCep) != estadoLocal) {

            if ((cepLocal != "") || (logradouroLocal != "") || (bairroLocal != "") || (cidadeLocal != "") || (codIbge != "")) {
                setLogradouroLocal('');
                setBairroLocal('');
                setCidadeLocal('');
                setCodIbge('');
                setCepLocal('');
                setNumeroLocal('');
                setComplementoLocal('');


                let input = document.querySelector("#cepLocal");
                let select = document.querySelector("#estado");

                input.classList.add("error");
                select.classList.add("error");

                store.addNotification({
                    title: "Erro!",
                    message: "Este estado não pertence ao CEP informado!",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } else {


        }
    }

    // Fazenda editada (ex: veio da Omie sem cod_ibge) - busca na API pública do IBGE por
    // cidade+estado, em vez de exigir digitação manual (mesma lógica de AddLocalAplicacao).
    const normalizarTextoIbge = (texto) =>
        String(texto || '')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toLowerCase()
            .trim();

    const buscarCodigoIbgePorCidade = async (cidade, uf) => {
        try {
            const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`);
            if (!response.ok) return null;
            const municipios = await response.json();
            const alvo = normalizarTextoIbge(cidade);
            const encontrado = municipios.find((m) => normalizarTextoIbge(m.nome) === alvo);
            return encontrado ? String(encontrado.id) : null;
        } catch (error) {
            console.error('Erro ao buscar código IBGE automaticamente:', error);
            return null;
        }
    };

    useEffect(() => {
        if (!cidadeLocal || !estadoLocal || codIbge) return;

        let cancelado = false;
        setLoadingIbge(true);
        buscarCodigoIbgePorCidade(cidadeLocal, estadoLocal).then((codigo) => {
            if (cancelado) return;
            if (codigo) setCodIbge(codigo);
            setLoadingIbge(false);
        });

        return () => { cancelado = true; };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cidadeLocal, estadoLocal])

    const onSelect = (selectedList, selectedItem) => {
        let c = [];
        const a = selectedList.map((list) => {
            c.push(list.id)
        })

        setCulturassend(c);
    }

    const onRemove = (selectedList, removedItem) => {
        let c = [];
        const a = selectedList.map((list) => {
            c.push(list.id)
        })
        setCulturassend(c);
    }

    const validateEnderecoParaMapa = () => {
        let completo = true;

        if (!cepLocal) {
            setErroCep(true);
            setErroCepMsg('O campo CEP não pode estar vazio');
            completo = false;
        }
        if (!logradouroLocal) {
            setErroEndereco(true);
            setErroEnderecoMsg('O campo endereço não pode estar vazio');
            completo = false;
        }
        if (!numeroLocal) {
            setErroNumero(true);
            setErroNumeroMsg('O campo número não pode estar vazio');
            completo = false;
        }
        if (!bairroLocal) {
            setErroBairro(true);
            setErroBairroMsg('O campo bairro não pode estar vazio');
            completo = false;
        }
        if (!cidadeLocal) {
            setErroCidade(true);
            setErroCidadeMsg('O campo cidade não pode estar vazio');
            completo = false;
        }
        if (!estadoLocal) {
            setErroEstado(true);
            setErroEstadoMsg('O campo estado não pode estar vazio');
            completo = false;
        }

        return completo;
    }

    const changeModo = (e) => {

        if (e.value === 1 || e.value === 2) {
            if (e.value === 1) {
                const enderecoCompleto = validateEnderecoParaMapa();
                if (!enderecoCompleto) {
                    store.addNotification({
                        title: "Erro!",
                        message: "Preencha todos os campos referentes ao endereço do local de aplicação para abrir o mapa com as coordenadas geográficas.",
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                }
            }

            setModoCoord(e);
            setLatitude('');
            setLongitude('');

            // Limpar todos os erros de coordenadas ao trocar de modo
            setErroLatitude(false);
            setErroLongitude(false);
            setErroLatitudeGraus(false);
            setErroLatitudeMinutos(false);
            setErroLatitudeSegundos(false);
            setErroLongitudeGraus(false);
            setErroLongitudeMinutos(false);
            setErroLongitudeSegundos(false);

            if (e.value === 1) {
                setShowMap(true);
                setShowInput(false);
            } else if (e.value === 2) {
                setShowInput(true);
                setShowMap(false);
            }
        }
    }

    const changeCoordinates = (lat, lng) => {
        if (lat && lng) {
            setLatitude(lat);
            setLongitude(lng);

            // Limpar os campos de graus, minutos e segundos quando coordenadas são selecionadas pelo mapa
            setLatitudeGraus('');
            setLatitudeMinutos('');
            setLatitudeSegundos('');
            setLongitudeGraus('');
            setLongitudeMinutos('');
            setLongitudeSegundos('');

            // Limpar todos os erros de coordenadas quando selecionadas pelo mapa
            setErroLatitude(false);
            setErroLongitude(false);
            setErroLatitudeGraus(false);
            setErroLatitudeMinutos(false);
            setErroLatitudeSegundos(false);
            setErroLongitudeGraus(false);
            setErroLongitudeMinutos(false);
            setErroLongitudeSegundos(false);
        }
    }

    // Função para validar formato das coordenadas
    const validateCoordinatesFormat = () => {
        const requiredStates = ['ES', 'PR', 'GO', 'SC', 'SP'];
        const isRequired = requiredStates.includes(estadoLocal);

        // Reset dos erros específicos
        setErroLatitudeGraus(false);
        setErroLatitudeMinutos(false);
        setErroLatitudeSegundos(false);
        setErroLongitudeGraus(false);
        setErroLongitudeMinutos(false);
        setErroLongitudeSegundos(false);

        // Se coordenadas foram selecionadas pelo mapa (latitude e longitude existem mas campos manuais estão vazios)
        if (latitude && longitude && !latitudeGraus && !latitudeMinutos && !latitudeSegundos && !longitudeGraus && !longitudeMinutos && !longitudeSegundos) {
            return { isValid: true }; // Coordenadas do mapa são sempre válidas
        }

        // Se coordenadas são obrigatórias
        if (isRequired) {
            // Validação de latitude
            if (!latitudeGraus || latitudeGraus.length !== 2) {
                setErroLatitudeGraus(true);
                return { isValid: false, message: "Latitude: Graus deve ter exatamente 2 dígitos" };
            }
            if (!latitudeMinutos || latitudeMinutos.length !== 2) {
                setErroLatitudeMinutos(true);
                return { isValid: false, message: "Latitude: Minutos deve ter exatamente 2 dígitos" };
            }
            if (!latitudeSegundos || latitudeSegundos.length !== 4) {
                setErroLatitudeSegundos(true);
                return { isValid: false, message: "Latitude: Segundos deve ter exatamente 4 dígitos" };
            }

            // Validação de longitude
            if (!longitudeGraus || longitudeGraus.length !== 2) {
                setErroLongitudeGraus(true);
                return { isValid: false, message: "Longitude: Graus deve ter exatamente 2 dígitos" };
            }
            if (!longitudeMinutos || longitudeMinutos.length !== 2) {
                setErroLongitudeMinutos(true);
                return { isValid: false, message: "Longitude: Minutos deve ter exatamente 2 dígitos" };
            }
            if (!longitudeSegundos || longitudeSegundos.length !== 4) {
                setErroLongitudeSegundos(true);
                return { isValid: false, message: "Longitude: Segundos deve ter exatamente 4 dígitos" };
            }
        } else {
            // Se coordenadas são opcionais, mas foram preenchidas, validar formato
            if (latitudeGraus || latitudeMinutos || latitudeSegundos) {
                if (latitudeGraus && latitudeGraus.length !== 2) {
                    setErroLatitudeGraus(true);
                    return { isValid: false, message: "Latitude: Graus deve ter exatamente 2 dígitos" };
                }
                if (latitudeMinutos && latitudeMinutos.length !== 2) {
                    setErroLatitudeMinutos(true);
                    return { isValid: false, message: "Latitude: Minutos deve ter exatamente 2 dígitos" };
                }
                if (latitudeSegundos && latitudeSegundos.length !== 4) {
                    setErroLatitudeSegundos(true);
                    return { isValid: false, message: "Latitude: Segundos deve ter exatamente 4 dígitos" };
                }
            }

            if (longitudeGraus || longitudeMinutos || longitudeSegundos) {
                if (longitudeGraus && longitudeGraus.length !== 2) {
                    setErroLongitudeGraus(true);
                    return { isValid: false, message: "Longitude: Graus deve ter exatamente 2 dígitos" };
                }
                if (longitudeMinutos && longitudeMinutos.length !== 2) {
                    setErroLongitudeMinutos(true);
                    return { isValid: false, message: "Longitude: Minutos deve ter exatamente 2 dígitos" };
                }
                if (longitudeSegundos && longitudeSegundos.length !== 4) {
                    setErroLongitudeSegundos(true);
                    return { isValid: false, message: "Longitude: Segundos deve ter exatamente 4 dígitos" };
                }
            }
        }

        return { isValid: true };
    };

    const validateLatitude = async (tipo, valor) => {
        // Limpar erros ao começar a digitar
        setErroLatitude(false);
        setErroLatitudeGraus(false);
        setErroLatitudeMinutos(false);
        setErroLatitudeSegundos(false);

        if (tipo === 1) {

            if (latitudeGraus.length > valor.length) {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLatitudeGraus(`${separa[0]}${separa[1]}`);
                    } else {
                        setLatitudeGraus(valor);
                    }
                } else {
                    setLatitudeGraus(valor);
                }

            } else {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLatitudeGraus(valor);
                    } else {

                        if (separa[2] === ',') {
                            setLatitudeGraus(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLatitudeGraus(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLatitudeGraus(valor);
                }
            }

        } else if (tipo === 2) {

            if (latitudeMinutos.length > valor.length) {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLatitudeMinutos(`${separa[0]}${separa[1]}`);
                    } else {
                        setLatitudeMinutos(valor);
                    }
                } else {
                    setLatitudeMinutos(valor);
                }
            } else {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLatitudeMinutos(valor);
                    } else {

                        if (separa[2] === ',') {
                            setLatitudeMinutos(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLatitudeMinutos(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLatitudeMinutos(valor);
                }
            }

        } else if (tipo === 3) {
            if (latitudeSegundos.length > valor.length) {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLatitudeSegundos(`${separa[0]}${separa[1]}`)
                    } else {
                        setLatitudeSegundos(valor);
                    }
                } else {
                    setLatitudeSegundos(valor);
                }
            } else {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLatitudeSegundos(valor);
                    } else {

                        if (separa[2] === ',') {
                            setLatitudeSegundos(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLatitudeSegundos(`${separa[0]}${separa[1]}.${separa[2]}`);

                        }
                    }
                } else {
                    setLatitudeSegundos(valor);
                }
            }
        }
    }

    const validateLongitude = async (tipo, valor) => {
        // Limpar erros ao começar a digitar
        setErroLongitude(false);
        setErroLongitudeGraus(false);
        setErroLongitudeMinutos(false);
        setErroLongitudeSegundos(false);

        if (tipo === 1) {

            if (longitudeGraus.length > valor.length) {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLongitudeGraus(`${separa[0]}${separa[1]}`);
                    } else {
                        setLongitudeGraus(valor);

                    }
                } else {
                    setLongitudeGraus(valor);
                }
            } else {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLongitudeGraus(valor);
                    } else {

                        if (separa[2] === ',') {
                            setLongitudeGraus(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLongitudeGraus(`${separa[0]}${separa[1]}.${separa[2]}`);

                        }
                    }
                } else {
                    setLongitudeGraus(valor);
                }
            }

        } else if (tipo === 2) {

            if (longitudeMinutos.length > valor.length) {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLongitudeMinutos(`${separa[0]}${separa[1]}`);
                    } else {
                        setLongitudeMinutos(valor);
                    }
                } else {
                    setLongitudeMinutos(valor);
                }
            } else {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLongitudeMinutos(valor);
                    } else {

                        if (separa[2] === ',') {
                            setLongitudeMinutos(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLongitudeMinutos(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLongitudeMinutos(valor);
                }
            }

        } else if (tipo === 3) {

            if (longitudeSegundos.length > valor.length) {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLongitudeSegundos(`${separa[0]}${separa[1]}`);
                    } else {
                        setLongitudeSegundos(valor);

                    }
                } else {
                    setLongitudeSegundos(valor);
                }
            } else {
                if (valor.length === 3) {
                    let separa = valor.split("");
                    if (separa[2] === ".") {
                        setLongitudeSegundos(valor);
                    } else {
                        if (separa[2] === ',') {
                            setLongitudeSegundos(`${separa[0]}${separa[1]}.`);
                        } else {
                            setLongitudeSegundos(`${separa[0]}${separa[1]}.${separa[2]}`);
                        }
                    }
                } else {
                    setLongitudeSegundos(valor);
                }
            }
        }
    }

    const modalClose = e => {
        if (showModal === true) {
            setShowModal(false);
        }
        if (showModalYesNo === true) {
            setShowModalYesNo(false);
        }
    }

    const updateResposta = async (resposta) => {

        if (resposta === 1) {
            setRespostaArt(resposta);

            if ((enviadoCrea === true) && (respostaCrea === 1)) {

                const payload = {

                    nome: nomeLocal,
                    cpf_cnpj: cpfCnpjLocal,
                    inscricao_estadual: inscricaoEstadual,
                    cep: cepLocal,
                    endereco: logradouroLocal,
                    bairro: bairroLocal,
                    numero: numeroLocal,
                    complemento: complementoLocal,
                    cidade: cidadeLocal,
                    cod_ibge: codIbge,
                    estado: estadoLocal,
                    inscricao_orgao: numeroOrgao,
                    area_total: areaTotal,
                    cadastro_ambiental: cadastroAmbiental,
                    latitude,
                    longitude,
                    cultura: culturaId,
                    enviado_crea: respostaCrea,
                    alterar_dados_providenciar_nova_art: resposta,
                    alterar: 1,
                    exibeMensagem: 1

                };

                try {
                    const response = await api.put(`/fazendas/${id}/`, payload);
                    store.addNotification({
                        title: "Sucesso!",
                        message: "O local de aplicação foi editado corretamente.",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    props.history.push(`/produtores/${id_produtor}`);


                } catch (error) {
                    store.addNotification({
                        title: "Erro!",
                        message: identifyErrorMenssage(error),
                        type: "danger",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                }
            } else {

                if ((enviadoCrea === true) && (respostaCrea === 0)) {

                    const payload = {

                        nome: nomeLocal,
                        cpf_cnpj: cpfCnpjLocal,
                        inscricao_estadual: inscricaoEstadual,
                        cep: cepLocal,
                        endereco: logradouroLocal,
                        bairro: bairroLocal,
                        numero: numeroLocal,
                        complemento: complementoLocal,
                        cidade: cidadeLocal,
                        cod_ibge: codIbge,
                        estado: estadoLocal,
                        inscricao_orgao: numeroOrgao,
                        area_total: areaTotal,
                        cadastro_ambiental: cadastroAmbiental,
                        latitude,
                        longitude,
                        cultura: culturaId,
                        enviado_crea: respostaCrea,
                        alterar_dados_providenciar_nova_art: resposta
                    };
                    try {
                        const response = await api.put(`/fazendas/${id}/`, payload);
                        store.addNotification({
                            title: "Sucesso!",
                            message: "O local de aplicação foi editado corretamente.",
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });
                        props.history.push(`/produtores/${id_produtor}`);

                    } catch (error) {
                        store.addNotification({
                            title: "Sucesso!",
                            message: "O local de aplicação foi editado corretamente.",
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });
                        props.history.push(`/produtores/${id_produtor}`);
                    }
                }

                if (enviadoCrea === false) {

                    const payload = {

                        nome: nomeLocal,
                        cpf_cnpj: cpfCnpjLocal,
                        inscricao_estadual: inscricaoEstadual,
                        cep: cepLocal,
                        endereco: logradouroLocal,
                        bairro: bairroLocal,
                        numero: numeroLocal,
                        complemento: complementoLocal,
                        cidade: cidadeLocal,
                        cod_ibge: codIbge,
                        estado: estadoLocal,
                        inscricao_orgao: numeroOrgao,
                        area_total: areaTotal,
                        cadastro_ambiental: cadastroAmbiental,
                        latitude,
                        longitude,
                        cultura: culturaId,
                        alterar_dados_providenciar_nova_art: resposta,
                        alterar: 1,
                        exibeMensagem: 1
                    };

                    try {
                        const response = await api.put(`/fazendas/${id}/`, payload);

                        store.addNotification({
                            title: "Sucesso!",
                            message: "O local de aplicação foi editado corretamente.",
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });
                        props.history.push(`/produtores/${id_produtor}`);


                    } catch (error) {
                        store.addNotification({
                            title: "Sucesso!",
                            message: "O local de aplicação foi editado corretamente.",
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });
                        props.history.push(`/produtores/${id_produtor}`);
                    }
                }
            }
            setShowModal(false);

        } else {
            setRespostaArt(0);

            if (enviadoCrea === true) {
                if (respostaCrea === 1) {
                    const payload = {
                        nome: nomeLocal,
                        cpf_cnpj: cpfCnpjLocal,
                        inscricao_estadual: inscricaoEstadual,
                        cep: cepLocal,
                        endereco: logradouroLocal,
                        bairro: bairroLocal,
                        numero: numeroLocal,
                        complemento: complementoLocal,
                        cidade: cidadeLocal,
                        cod_ibge: codIbge,
                        estado: estadoLocal,
                        inscricao_orgao: numeroOrgao,
                        area_total: areaTotal,
                        cadastro_ambiental: cadastroAmbiental,
                        latitude,
                        longitude,
                        cultura: culturaId,
                        enviado_crea: respostaCrea,
                        alterar_dados_providenciar_nova_art: resposta,
                        exibeMensagem: 1,
                        alterar: 0
                    };


                    try {
                        const response = await api.put(`/fazendas/${id}/`, payload);

                        if (response.data.message != "") {
                            setMsg2(response.data.message)
                            setShowModalText(true);
                        }
                    } catch (error) {
                        store.addNotification({
                            title: "Sucesso!",
                            message: "O local de aplicação foi editado corretamente",
                            type: "success",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animated", "fadeIn"],
                            animationOut: ["animated", "fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });

                        props.history.push(`/produtores/${id_produtor}`);
                    }

                } else {
                    if (respostaCrea === 0) {
                        const payload = {
                            nome: nomeLocal,
                            cpf_cnpj: cpfCnpjLocal,
                            inscricao_estadual: inscricaoEstadual,
                            cep: cepLocal,
                            endereco: logradouroLocal,
                            bairro: bairroLocal,
                            numero: numeroLocal,
                            complemento: complementoLocal,
                            cidade: cidadeLocal,
                            cod_ibge: codIbge,
                            estado: estadoLocal,
                            inscricao_orgao: numeroOrgao,
                            area_total: areaTotal,
                            cadastro_ambiental: cadastroAmbiental,
                            latitude,
                            longitude,
                            cultura: culturaId,
                            enviado_crea: respostaCrea,
                            alterar_dados_providenciar_nova_art: resposta
                        };
                        try {
                            const response = await api.put(`/fazendas/${id}/`, payload);
                            store.addNotification({
                                title: "Sucesso!",
                                message: "O local de aplicação foi editado corretamente",
                                type: "success",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 5000,
                                    onScreen: true
                                }
                            });
                            props.history.push(`/produtores/${id_produtor}`);
                        } catch (error) {
                            store.addNotification({
                                title: "Sucesso!",
                                message: "O local de aplicação foi editado corretamente",
                                type: "success",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 5000,
                                    onScreen: true
                                }
                            });

                            props.history.push(`/produtores/${id_produtor}`);

                        }
                    }
                }



            } else {
                const payload = {

                    nome: nomeLocal,
                    cpf_cnpj: cpfCnpjLocal,
                    inscricao_estadual: inscricaoEstadual,
                    cep: cepLocal,
                    endereco: logradouroLocal,
                    bairro: bairroLocal,
                    numero: numeroLocal,
                    complemento: complementoLocal,
                    cidade: cidadeLocal,
                    cod_ibge: codIbge,
                    estado: estadoLocal,
                    inscricao_orgao: numeroOrgao,
                    area_total: areaTotal,
                    cadastro_ambiental: cadastroAmbiental,
                    latitude,
                    longitude,
                    cultura: culturaId,
                    alterar_dados_providenciar_nova_art: resposta,
                    exibeMensagem: 1,
                    alterar: 0
                };

                try {
                    const response = await api.put(`/fazendas/${id}/`, payload);
                    if (response.data.message != "") {
                        setMsg2(response.data.message);
                        setShowModalText(true);
                    }

                } catch (error) {
                    store.addNotification({
                        title: "Sucesso!",
                        message: "O local de aplicação foi editado corretamente",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });

                    props.history.push(`/produtores/${id_produtor}`);
                }
            }
            setShowModal(false);
        }
    }

    const updateRespostaYesNo = async (resposta) => {
        if (resposta === 1) {
            const payload = {

                nome: nomeLocal,
                cpf_cnpj: cpfCnpjLocal,
                inscricao_estadual: inscricaoEstadual,
                cep: cepLocal,
                endereco: logradouroLocal,
                bairro: bairroLocal,
                numero: numeroLocal,
                complemento: complementoLocal,
                cidade: cidadeLocal,
                cod_ibge: codIbge,
                estado: estadoLocal,
                inscricao_orgao: numeroOrgao,
                area_total: areaTotal,
                cadastro_ambiental: cadastroAmbiental,
                latitude,
                longitude,
                cultura: culturaId,
                enviado_crea: resposta,
                alterar: 0,
                exibeMensagem: 1
            };

            try {
                const response = await api.put(`/fazendas/${id}`, payload);

                setEnviadoCrea(true);
                setRespostaCrea(resposta);
            } catch (error) {
                setMsg(error.response.data.errors);
                if (error.response.data.errors === "A alteração dos dados exige uma nova ART. O que você deseja fazer?") {
                    setEnviadoCrea(true);
                    setRespostaCrea(resposta);

                }
            }
            setShowModal(true);
        } else {
            const payload = {

                nome: nomeLocal,
                cpf_cnpj: cpfCnpjLocal,
                inscricao_estadual: inscricaoEstadual,
                cep: cepLocal,
                endereco: logradouroLocal,
                bairro: bairroLocal,
                numero: numeroLocal,
                complemento: complementoLocal,
                cidade: cidadeLocal,
                cod_ibge: codIbge,
                estado: estadoLocal,
                inscricao_orgao: numeroOrgao,
                area_total: areaTotal,
                cadastro_ambiental: cadastroAmbiental,
                latitude,
                longitude,
                cultura: culturaId,
                enviado_crea: respostaCrea,
                alterar: 0,
                exibeMensagem: 1
            };
            let mensagem;

            try {
                const response = await api.put(`/fazendas/${id}/`, payload);

                setEnviadoCrea(true);
                setRespostaCrea(resposta);
                if (response.data.message != "") {
                    setMsg2(response.data.message);
                    setShowModalText(true);
                }

            } catch (error) {
                store.addNotification({
                    title: "Sucesso!",
                    message: "Estamos alterando os dados sob sua responsabilidade, considerando que os contratos da ART ainda não foram enviados para o CREA. Local de aplicação será mantido como ATIVO na ART",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 7000,
                        onScreen: true
                    }
                });
                props.history.push(`/produtores/${id_produtor}`);
            }
        }
        setShowModalYesNo(false);
    }

    const closeOk = e => {
        setShowModalText(false);
    }

    const updateOk = async (resposta) => {
        if (resposta === 1) {
            setShowModalText(false);

            const payload = {

                nome: nomeLocal,
                cpf_cnpj: cpfCnpjLocal,
                inscricao_estadual: inscricaoEstadual,
                cep: cepLocal,
                endereco: logradouroLocal,
                bairro: bairroLocal,
                numero: numeroLocal,
                complemento: complementoLocal,
                cidade: cidadeLocal,
                cod_ibge: codIbge,
                estado: estadoLocal,
                inscricao_orgao: numeroOrgao,
                area_total: areaTotal,
                cadastro_ambiental: cadastroAmbiental,
                latitude,
                longitude,
                cultura: culturaId,
                enviado_crea: respostaCrea,
                alterar_dados_providenciar_nova_art: respostaArt,
                exibeMensagem: 1,
                alterar: 1,
            };

            try {
                await api.put(`/fazendas/${id}/`, payload);
                store.addNotification({
                    title: "Sucesso!",
                    message: "O local de aplicação foi editado corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });

                props.history.push(`/produtores/${id_produtor}`);

            } catch (err) {

                let inputWithErrors = document.querySelectorAll(".error");

                for (let input of inputWithErrors) {
                    input.classList.remove("error");
                }

                const errors = err.response.data.errors;


                for (let field in errors) {
                    const input = document.getElementById(field);
                    input.classList.add("error");
                }

                store.addNotification({
                    title: "Erro!",
                    message: "Verifique os campos em vermelho",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }

        } else {
            setShowModalText(false);
        }
    }

    const goBack = () => {
        if (props.isModal) {
            props.openModal(false);
        } else {
            props.history.goBack();
        }
    }

    const editPost = async e => {
        setLoading(true);

        // Validação de formato de coordenadas
        const coordValidation = validateCoordinatesFormat();
        if (!coordValidation.isValid) {
            store.addNotification({
                title: "Erro",
                message: coordValidation.message,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
            setLoading(false);
            return;
        }

        if (erroCpf === true) {
            setLoading(false);
            store.addNotification({
                title: "Erro!",
                message: "Informe um CPF válido!",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        } else {
            let lat = latitude;
            let lng = longitude;

            // Só usar os campos manuais se não houver coordenadas do mapa
            if ((!lat || lat === '') && (!lng || lng === '')) {
                if (latitudeGraus && latitudeMinutos && latitudeSegundos && longitudeGraus && longitudeMinutos && longitudeSegundos) {
                    lat = `${latitudeGraus}°${latitudeMinutos}'${latitudeSegundos}"S`;
                    lng = `${longitudeGraus}°${longitudeMinutos}'${longitudeSegundos}"W`;
                }
            }


            const newcultures = [...new Set(culturassend)];

            let existErro = false;

            if (isEstadoObrigatorio(estadoLocal)) {
                if (lat === '' || lat === `°'"S`) {
                    setErroLatitude(true);
                    existErro = true;
                }
                if (lng === '' || lng === `°'"W`) {
                    setErroLongitude(true);
                    existErro = true;

                }

                if (estadoLocal === 'SC' && altitude === '') {
                    setErroAltitude(true);
                    existErro = true;

                }
            }

            if (
                bairroLocal == '' || nomeLocal == '' || cpfCnpjLocal == '' || cepLocal == '' || logradouroLocal == '' ||
                cidadeLocal == '' || estadoLocal == '' || numeroLocal == '' || codIbge == '' || bairroLocal == ''
            ) {
                existErro = true;

                if (bairroLocal == '') {
                    setErroBairroMsg('O campo bairro não pode estar vazio');
                    setErroBairro(true);
                }

                if (nomeLocal == '') {
                    setErroNomeMsg('O campo nome não pode estar vazio');
                    setErroNome(true);
                }

                if (cpfCnpjLocal == '') {
                    setErroCpfMsg('O campo CPF/CNPJ não pode estar vazio');
                    setErroCpf(true);
                }

                if (cepLocal == '') {
                    setErroCepMsg('O campo CEP não pode estar vazio');
                    setErroCep(true);
                }

                if (logradouroLocal == '') {
                    setErroEnderecoMsg('O campo endereço não pode estar vazio');
                    setErroEndereco(true);
                }

                if (cidadeLocal == '') {
                    setErroCidadeMsg('O campo cidade não pode estar vazio');
                    setErroCidade(true);
                }

                if (estadoLocal == '') {
                    setErroEstadoMsg('O campo estado não pode estar vazio');
                    setErroEstado(true);
                }

                if (numeroLocal == '') {
                    setErroNumeroMsg('O campo número não pode estar vazio');
                    setErroNumero(true);
                }

                if (codIbge == '') {
                    setErroIbgeMsg('O campo código IBGE não pode estar vazio');
                    setErroIbge(true);
                }
            }

            if (existErro === false) {

                function isValidCoordinate(coord) {
                    // Se for um número válido, aceita
                    if (typeof coord === 'number' && !isNaN(coord)) return true;

                    // Se não for string, rejeita
                    if (!coord || typeof coord !== 'string') return false;

                    // Verifica se contém os padrões inválidos para strings
                    const invalidPatterns = [
                        /°'\"[NSEW]$/i, // °'"N, °'"S, etc.
                        /^°'\"$/i,       // apenas °'"
                        /^\s*$/,         // string vazia ou só espaços
                        /^undefined$/i,
                        /^null$/i
                    ];

                    return !invalidPatterns.some(pattern => pattern.test(coord));
                }

                const payload = {
                    nome: nomeLocal,
                    cpf_cnpj: cpfCnpjLocal,
                    inscricao_estadual: inscricaoEstadual,
                    cep: cepLocal,
                    endereco: logradouroLocal,
                    bairro: bairroLocal,
                    numero: numeroLocal,
                    complemento: complementoLocal,
                    cidade: cidadeLocal,
                    cod_ibge: codIbge,
                    estado: estadoLocal,
                    inscricao_orgao: numeroOrgao,
                    area_total: areaTotal,
                    cadastro_ambiental: cadastroAmbiental,
                    latitude: isValidCoordinate(lat, 'lat') ? lat : null,
                    longitude: isValidCoordinate(lng, 'lng') ? lng : null,
                    altitude: altitude !== null ? altitude : '',
                    cultura: null,
                    exibeMensagem: 1,
                    status: statusLocal
                };

                try {
                    const responseFarm = await api.put(`/fazendas/${id}`, payload);

                    if (responseFarm) {
                        const id_fazenda = id;

                        const payload_culturas = {
                            agro_farms_id: parseInt(id_fazenda),
                            agro_producers_id: parseInt(id_produtor),
                            cultura: newcultures,
                            status: 1
                        }

                        const responseCulturas = await api.post(`/fazenda/culturas`, payload_culturas);
                        if (responseCulturas) {
                            if (responseCulturas.status === 200) {
                                setLoading(false);

                                if (props.isModal) {
                                    props.openModal(false);
                                } else {
                                    props.history.push(`/produtores/${id_produtor}`);
                                }
                                store.addNotification({
                                    title: "Sucesso!",
                                    message: "O local de aplicação foi editado corretamente.",
                                    type: "success",
                                    insert: "top",
                                    container: "top-right",
                                    animationIn: ["animated", "fadeIn"],
                                    animationOut: ["animated", "fadeOut"],
                                    dismiss: {
                                        duration: 5000,
                                        onScreen: true
                                    }
                                });
                            }
                        }
                    }

                } catch (err) {

                    if (err.response.status === 409) {
                        setLoading(false);

                        const arts = err.response.data.data.arts;
                        const contracts = err.response.data.data.contratos;
                        const payloadFarm = err.response.data.data.payload_farm;

                        resolveFarmConflict(arts, contracts, payloadFarm);
                    } else {
                        setLoading(false);

                        const errors = err.response.data.errors;

                        if (err.response.data.message === "(Apenas alterar os dados) alterar_dados_providenciar_nova_art => 0 ou (Alterar os dados e providenciar uma nova ART) alterar_dados_providenciar_nova_art => 1") {
                            setMsg(errors);
                            setShowModal(true);
                        } else {
                            setLoading(false);
                            store.addNotification({
                                title: "Erro!",
                                message: identifyErrorMenssage(err),
                                type: "danger",
                                insert: "top",
                                container: "top-right",
                                animationIn: ["animated", "fadeIn"],
                                animationOut: ["animated", "fadeOut"],
                                dismiss: {
                                    duration: 4000,
                                    onScreen: true
                                }
                            });
                        }
                    }

                }

            } else {
                setLoading(false);
                store.addNotification({
                    title: "Erro!",
                    message: "Verifique os campos em vermelho",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }

    };

    const resolveFarmConflict = async (arts, contracts, payloadFarm) => {
        setResolveConflict({
            arts,
            contracts,
            payloadFarm
        });

        // Pré-preenche a decisão do usuário com defaults
        const defaults = arts.map((art) => ({
            enviado_crea: art.exist_prescription === true ? true : false,
            agro_crea_id: art.agro_crea_id,
            numero_art: art.numero_art,
            exist_prescription: art.exist_prescription === true ? true : false,
        }));
        setResponseConflict(defaults);

        setModalGeneric(
            <div style={{
                width: '100%',
                padding: '10px',
            }}>
                <h2>Atenção</h2>
                <p>Este local de aplicação está vinculado em {contracts.length} {contracts.length > 1 ? `contratos ativos` : `contrato ativo`}.</p>
                <p>Confirme se os dados já foram enviados ao CREA para continuar com a edição do local de aplicação.</p>
                <table style={{
                    width: '100%',
                    height: 'auto',
                    margin: 'auto',
                    marginBottom: '20px'
                }}>
                    <tr>
                        <th style={{ border: '1px solid #000', padding: '5px' }}>ART</th>
                        <th style={{ border: '1px solid #000', padding: '5px' }}>Existem receitas emitidas?</th>
                        <th style={{ border: '1px solid #000', padding: '5px' }}>CREA</th>
                    </tr>
                    {arts.map((art, i) => (
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px' }}>{art.numero_art}</td>
                            <td style={{ border: '1px solid #000', padding: '5px' }}>{art.exist_prescription === true ? 'SIM' : 'NÃO'}</td>
                            <td style={{ border: '1px solid #000', padding: '5px' }}> <YesNoContainer disabled={false} loading={false}> <span>Dados enviados ao CREA?</span> <Interruptor disabled={art.exist_prescription} value={art.exist_prescription === true ? true : responseConflict[i] ? responseConflict[i].enviado_crea : false} onChange={(e) => saveFarmConflict(e, art.numero_art, art.exist_prescription, art.agro_crea_id, i)} /> </YesNoContainer></td>
                        </tr>
                    ))}


                </table>

                <p style={{ width: '100%', fontSize: '75%' }}><span style={{ color: '#F10' }}>*</span>Para as ARTs com os dados <u>já enviados ao CREA</u> é exigido uma nova ART, nesse caso estaremos <b>inativando</b> o contrato na ART vigente.</p>
                <p style={{ width: '100%', fontSize: '75%' }}><span style={{ color: '#F10' }}>*</span>Para as ARTs com os dados <u>não enviados ao CREA</u>, estaremos <b>alterando</b> os dados sob sua responsabilidade, mantendo o local de aplicação como <b>ativo</b> na ART vigente.</p>
                <p style={{ width: '100%', fontSize: '75%' }}><span style={{ color: '#F10' }}>*</span>Para as ARTs que possuem receitas emitidas vamos considerar que os dados <b><u>já foram enviados ao CREA</u></b>.</p>

                <div
                    className="button-finish"
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '20px',
                        marginBottom: '20px',
                    }}
                >
                    <Button
                        width='255px'
                        height='50px'
                        value='CONFIRMAR'
                        outline={false}
                        disabled={false}
                        onClick={() => confirmFarmConflict(payloadFarm)}
                        loading={false}
                    />


                </div>
            </div>
        )

        setShowModalGeneric(true);
    }

    const saveFarmConflict = (enviado, numArt, existPrescription, agroCreaId, index) => {
        let resolve = responseConflict;

        resolve[index] = {
            enviado_crea: existPrescription === true ? true : enviado,
            agro_crea_id: agroCreaId,
            numero_art: numArt,
            exist_prescription: existPrescription
        };

        setResponseConflict(resolve);
    }

    const confirmFarmConflict = async (payloadFarm) => {
        setModalGeneric(<></>);
        setShowModalGeneric(false);
        setLoading(true);

        // Fallback: se não mexeu no toggle, usa os defaults
        const artsPayload = (responseConflict && responseConflict.length > 0)
            ? responseConflict
            : (resolveConflict.arts || []).map((art) => ({
                enviado_crea: art.exist_prescription === true ? true : false,
                agro_crea_id: art.agro_crea_id,
                numero_art: art.numero_art,
                exist_prescription: art.exist_prescription === true ? true : false,
            }));

        const payload = {
            arts: artsPayload,
            payload_farm: resolveConflict.payloadFarm || payloadFarm
        }

        try {
            const response = await api.put(`/fazendas/${id}/confirmar`, payload);

            if (response) {
                setLoading(false);
                props.history.push(`/produtores/${id_produtor}`);

                store.addNotification({
                    title: "Sucesso!",
                    message: "O local de aplicação foi editado corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
            setLoading(false);

        }
    }


    useEffect(() => {
        window.scrollTo(0, 0);
        inicializa();
    }, [])

    // O mapa sempre centraliza pelo endereço atual do formulário (geocodificado), em vez de
    // usar uma latitude/longitude já salva anteriormente — evita mostrar um local desatualizado
    // ou incorreto quando o endereço salvo estiver errado.
    const enderecoAtualCompleto = [logradouroLocal, numeroLocal, bairroLocal, cidadeLocal, estadoLocal, cepLocal].filter(Boolean).join(', ');

    return (
        <>
            {props.isModal === true ? (
                <h4 style={{ textAlign: 'center' }}>Edição do Local de Aplicação</h4>
            ) : (
                <GenericUpper
                    title="Edição do Local de Aplicação"
                    subtitle="Edite esta Fazenda"
                ></GenericUpper>
            )}

            <ProdutoresAddContainer {...props} isPage={true}>
                <Container>
                    <form>
                        <Input
                            label="Nome da fazenda"
                            labelWithAsterisk={true}
                            value={nomeLocal}
                            name="nome"
                            className="input"
                            id="nomeId"
                            erro={erroNome}
                            messageErro={erroNomeMsg}
                            onChange={e => validateNome(e)}
                            maxlength={50}
                            disabled={isTotvs() && !isOmie()}
                        />

                        <Input
                            label="CPF/CNPJ"
                            labelWithAsterisk={true}
                            value={formatCPFOrCNPJ(cpfCnpjLocal)}
                            name="cpfCnpj"
                            className="input"
                            id="cpf_cnpjId"
                            onChange={e => validateCpfCnpjLocal(e)}
                            onBlur={(e) => validaCpf(e.target.value)}
                            erro={erroCpf}
                            messageErro={erroCpfMsg}
                            inputmode="numeric"
                            disabled={isTotvs() && !isOmie()}
                        />

                        <Input
                            label="Inscrição Estadual"
                            value={inscricaoEstadual}
                            name="inscricaoEstadual"
                            className="input"
                            id="inscricao_estadualId"
                            onChange={e => setInscricaoEstadual(e)}
                            disabled={isTotvs() && !isOmie()}
                        />
                        <Input
                            label="CEP"
                            labelWithAsterisk={true}
                            id='cepId'
                            value={formatCEP(cepLocal)}
                            messageErro={erroCepMsg}
                            className="input"
                            name="cep"
                            erro={erroCep}
                            onChange={e => fetchCep(e)}
                            onBlur={(e) => validaCep(e.target.value)}
                            inputmode="numeric"
                            disabled={isTotvs() && !isOmie()}
                        />

                        <Input
                            label="Logradouro"
                            labelWithAsterisk={true}
                            value={logradouroLocal}
                            name="logradouroLocal"
                            className="input"
                            id="enderecoId"
                            erro={erroEndereco}
                            messageErro={erroEnderecoMsg}
                            onChange={e => { setLogradouroLocal(e); setErroEndereco(false); }}
                            disabled={isTotvs() && !isOmie()}
                        />

                        <Input
                            label="Número"
                            labelWithAsterisk={true}
                            value={numeroLocal}
                            name="numeroLocal"
                            className="input"
                            id="numeroId"
                            erro={erroNumero}
                            messageErro={erroNumeroMsg}
                            onChange={e => validateNumero(e)}
                            disabled={isTotvs() && !isOmie()}
                        />
                        <Input
                            label="Complemento"
                            value={complementoLocal}
                            name="complementoLocal"
                            className="input"
                            id="complementoLocalId"
                            onChange={e => setComplementoLocal(e)}
                            disabled={isTotvs() && !isOmie()}
                        />

                        <Input
                            label="Bairro"
                            labelWithAsterisk={true}
                            value={bairroLocal}
                            name="bairroLocal"
                            className="input"
                            id="bairroId"
                            erro={erroBairro}
                            messageErro={erroBairroMsg}
                            onChange={e => { setBairroLocal(e); setErroBairro(false); }}
                            disabled={isTotvs() && !isOmie()}
                        />

                        <Input
                            label="Cidade"
                            labelWithAsterisk={true}
                            value={cidadeLocal}
                            name="cidadeLocal"
                            className="input"
                            id="cidadeId"
                            erro={erroCidade}
                            messageErro={erroCidadeMsg}
                            onChange={e => { setCidadeLocal(e); setErroCidade(false); }}
                            disabled={isTotvs() && !isOmie()}
                        />

                        <Select
                            label="Estado"
                            labelWithAsterisk={true}
                            value={estadoLocal}
                            name="estado"
                            className="select"
                            id="estadoId"
                            // onChange={state => this.setState({ estadoLocal: state.value })}
                            onChange={state => { setEstadoLocal(state.value); setErroEstado(false); }}
                            options={estados}
                            onBlur={() => limpaCep()}
                            estado={true}
                            erro={erroEstado}
                            messageErro={false}
                            disabled={(isTotvs() && !isOmie()) || (estadoLocal.value || estadoLocal ? true : false)}

                        />

                        <Input
                            label="Código IBGE"
                            labelWithAsterisk={true}
                            value={codIbge}
                            name="codIbge"
                            className="input"
                            id="cod_ibge"
                            erro={erroIbge}
                            messageErro={erroIbgeMsg}
                            onChange={e => setCodIbge(e)}
                            inputmode="numeric"
                            loading={loadingIbge}
                            disabled={(isTotvs() && !isOmie()) || loadingIbge}
                        />
                        <Input
                            label="Número de inscrição do produtor ao órgão estadual"
                            value={numeroOrgao}
                            name="numeroOrgao"
                            className="input"
                            id="numeroOrgaoId"
                            onChange={e => setNumeroOrgao(e)}
                            disabled={isTotvs() && !isOmie()}
                        />
                        <Input
                            label="Área Total (ha)"
                            value={areaTotal}
                            name="areaTotal"
                            className="input"
                            id="areaTotalId"
                            onChange={e => setAreaTotal(e)}
                            marginBottom='20px'
                            inputmode="numeric"
                            disabled={isTotvs() && !isOmie()}
                        />

                        <ContainerInputCultura disabled={isTotvs() && !isOmie()}>
                            <label style={{ marginLeft: '20px', color: (isTotvs() && !isOmie()) ? theme.colors.disabled.Desabilitado_Medio : 'inherit' }} id="labelcultura">Culturas</label>
                            <Multiselect
                                style={{width: '100%'}}
                                className="multiSelectCulturas"
                                label="Culturas"
                                options={culturas}
                                placeholder="" // Options to display in the dropdown
                                selectedValues={selectedValues}
                                closeIcon="close"
                                onSelect={(list, item) => onSelect(list, item)}
                                onRemove={(list, item) => onRemove(list, item)}
                                displayValue="name" // Property name to display in the dropdown options
                                disable={isTotvs() && !isOmie()}
                            />

                        </ContainerInputCultura>

                        <Input
                            label="Cadastro Ambiental Rural"
                            value={cadastroAmbiental}
                            name="cadastroAmbientalRural"
                            className="input"
                            id="cadastroAmbientalRuralId"
                            // onChange={e => this.setState({ cadastroAmbiental: e })}
                            onChange={e => setCadastroAmbiental(e)}
                            marginBottom='20px'
                            disabled={isTotvs() && !isOmie()}
                        />

                        <Select
                            label="Selecionar coordenadas geográfica"
                            labelWithAsterisk={isEstadoObrigatorio(estadoLocal)}
                            name="select_coordinates"
                            className="select"
                            id="select_coordinates"
                            onChange={(e) => changeModo(e)}
                            options={[
                                { value: 1, label: 'Selecionar no mapa' },
                                { value: 2, label: 'Digitar coordenadas' },

                            ]}
                            value={modoCoord}
                            estado={false}
                            loading={false}
                            disabled={isTotvs() && !isOmie()}
                            erro={erroLatitude == true || erroLongitude == true || erroAltitude == true ? true : false}
                            messageErro={false}
                            marginBottom='45px'
                        />


                        {showMap ? (
                            cepLocal && logradouroLocal && numeroLocal && bairroLocal && cidadeLocal && estadoLocal ? (
                                <MapaArea
                                    label="Selecione o local de aplicação"
                                    endereco={enderecoAtualCompleto}
                                    onChange={(lat, lng) => changeCoordinates(lat, lng)}
                                    skipAutoLocateOnDesktop={true}
                                />
                            ) : null
                        ) : (<>
                            {showInput ? (
                                <>
                                    <label className='labelcoord'>{isEstadoObrigatorio(estadoLocal) ? "Latitude (Obrigatório)" : "Latitude (opcional)"}</label>
                                    <div className="coord">
                                        <div className="partCoord">
                                            <Input
                                                label='Graus'
                                                name="latitude"
                                                className="input"
                                                id="lgraus"
                                                value={latitudeGraus}
                                                maxLength={2}
                                                onChange={e => validateLatitude(1, e)}
                                                erro={erroLatitude || erroLatitudeGraus}
                                                inputmode="numeric"
                                                disabled={isTotvs() && !isOmie()}
                                            />
                                            <span>°</span>
                                        </div>

                                        <div className="partCoord">
                                            <Input
                                                label='Minutos'
                                                name="latitude"
                                                className="input"
                                                id="lminutos"
                                                value={latitudeMinutos}
                                                maxLength={2}
                                                onChange={e => validateLatitude(2, e)}
                                                style={{ marginTop: '16px' }}
                                                erro={erroLatitude || erroLatitudeMinutos}
                                                inputmode="numeric"
                                                disabled={isTotvs() && !isOmie()}
                                            />
                                            <span>'</span>
                                        </div>

                                        <div className="partCoord">
                                            <Input
                                                label='Segundos'
                                                name="latitude"
                                                className="input"
                                                id="lsegundos"
                                                value={latitudeSegundos}
                                                maxLength={4}
                                                onChange={e => validateLatitude(3, e)}
                                                style={{ marginTop: '16px' }}
                                                erro={erroLatitude || erroLatitudeSegundos}
                                                inputmode="numeric"
                                                disabled={isTotvs() && !isOmie()}
                                            />
                                            <span>"S</span>
                                        </div>
                                    </div>

                                    <label className='labelcoord'>{isEstadoObrigatorio(estadoLocal) ? "Longitude (Obrigatório)" : "Longitude (opcional)"}</label>
                                    <div className="coord">
                                        <div className="partCoord">
                                            <Input
                                                label='Graus'
                                                name="longitude"
                                                className="input"
                                                id="longrau"
                                                value={longitudeGraus}
                                                maxLength={2}
                                                onChange={e => validateLongitude(1, e)}
                                                erro={erroLongitude || erroLongitudeGraus}
                                                inputmode="numeric"
                                                disabled={isTotvs() && !isOmie()}
                                            />
                                            <span>°</span>
                                        </div>

                                        <div className="partCoord">
                                            <Input
                                                label='Minutos'
                                                name="longitude"
                                                className="input"
                                                id="lonminutos"
                                                value={longitudeMinutos}
                                                maxLength={2}
                                                onChange={e => validateLongitude(2, e)}
                                                style={{ marginTop: '16px' }}
                                                erro={erroLongitude || erroLongitudeMinutos}
                                                inputmode="numeric"
                                                disabled={isTotvs() && !isOmie()}
                                            />
                                            <span>'</span>
                                        </div>

                                        <div className="partCoord">
                                            <Input
                                                label='Segundos'
                                                name="longitude"
                                                className="input"
                                                id="lonsegundos"
                                                value={longitudeSegundos}
                                                maxLength={4}
                                                onChange={e => validateLongitude(3, e)}
                                                style={{ marginTop: '16px' }}
                                                erro={erroLongitude || erroLongitudeSegundos}
                                                inputmode="numeric"
                                                disabled={isTotvs() && !isOmie()}
                                            />
                                            <span>"W</span>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <></>
                            )}
                        </>)}

                        {estadoLocal === 'SC' ? (
                            <Input
                                label="Altitude (Obrigatório)"
                                value={altitude}
                                name="altitude"
                                className="input"
                                id="altitude"
                                onChange={e => {
                                    setAltitude(e);
                                    setErroAltitude(false);
                                }}
                                unidade="Metros"
                                erro={erroAltitude}
                                inputmode="numeric"
                                disabled={isTotvs() && !isOmie()}
                            />
                        ) : (null)}

                        <Select
                            name="status"
                            value={statusLocal}
                            label="Status"
                            className="select"
                            id="status"
                            onChange={status => setStatusLocal(status.value)}
                            options={[
                                { label: 'Ativo', value: 1 },
                                { label: 'Inativo', value: 0 }
                            ]}
                            marginBottom='45px'
                            disabled={isTotvs() && !isOmie()}
                        />

                        <ModalEditLocal
                            show={showModal}
                            onHide={() => modalClose()}
                            resposta=''
                            update={(e) => updateResposta(e)}
                            title='Atenção!'
                            text={msg}
                        ></ModalEditLocal>

                        <ModalYesNo
                            show={showModalYesNo}
                            onHide={() => modalClose()}
                            resposta=''
                            update={(e) => updateRespostaYesNo(e)}
                            title='Atenção!'
                            text={msg}
                            btnNo={true}
                        ></ModalYesNo>

                        <ModalText
                            show={showModalText}
                            onHide={() => closeOk()}
                            text={msg2}
                            btnOk={true}
                            btnCancelar={true}
                            update={(e) => updateOk(e)}
                        ></ModalText>

                        <Modal
                            show={showModalGeneric}
                            onHide={() => {
                                setShowModalGeneric(false);
                                setModalGeneric(false);
                            }}
                        >
                            {modalGeneric}
                        </Modal>

                        <div
                            className="button-finish"
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}
                        >
                            <Button
                                width='45%'
                                height='50px'
                                value='VOLTAR'
                                outline={true}
                                disabled={false}
                                onClick={() => goBack()}
                                loading={false}
                            />

                            <Button
                                width='45%'
                                height='50px'
                                value='SALVAR'
                                outline={false}
                                disabled={isTotvs() && !isOmie()}
                                onClick={() => editPost()}
                                loading={loading}
                            />

                        </div>
                    </form>
                </Container>
            </ProdutoresAddContainer>
        </>
    )

}

export default withRouter(EditLocal);
